import { Router } from 'vue-router'

import { useAuthStore } from '@/store/auth'
import { routeNames } from '@/router/route-names'

// Workaround, because no NavigationGuardWithThis export inside the `vue-router` package
type Guard = Parameters<Router['beforeEach']>[0]

const authMiddleware: Guard = to => {
  const authStore = useAuthStore()
  const isAuthenticated = authStore.isAuthenticated
  const currentUser = authStore.session?.user

  const [homePath, loginPath] = ['/', '/login']
  const guesRoutes = ['Login']

  const pageIsInGuestMode = guesRoutes.includes(to.name as string)

  if (!isAuthenticated && !pageIsInGuestMode) {
    return { path: loginPath }
  }

  if (isAuthenticated && pageIsInGuestMode) {
    return { path: homePath }
  }

  // Restrict statistics-viewer role to only access EV Statistics page
  // Restrict ev_car_owner role to only access My EV Cars Statistics page
  if (isAuthenticated && currentUser) {
    const isStatisticsViewer =
      currentUser.role === 'statistics-viewer' ||
      currentUser.ev_role === 'statistics-viewer'

    const isEvCarOwner = currentUser.ev_role === 'ev_car_owner'

    if (isStatisticsViewer) {
      // Allow access to EV Statistics page
      if (to.name === routeNames.evStatistic) {
        return
      }
      // Redirect all other pages to EV Statistics
      return { name: routeNames.evStatistic }
    }

    if (isEvCarOwner) {
      // Allow access to My EV Cars Statistics page
      if (to.name === routeNames.evOwnerStatistics) {
        return
      }
      // Redirect all other pages to My EV Cars Statistics
      return { name: routeNames.evOwnerStatistics }
    }
  }
}

export default authMiddleware
